import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserCreateRequestDTO, UserDeleteRequestDTO, UserDTO, UserList, UserMasterGetDictionaryRequestDTO, UserReadByUserIdRequestDTO, UserUpdateRequestDTO, UserUpdateStatusRequestDTO } from './user-master.interface';
import { UserMaster_create, UserMaster_delete, UserMaster_GetDictionary, UserMaster_readAll, UserMaster_readAllPaginated, UserMaster_readById, UserMaster_SearchByName, UserMaster_update, UserMaster_updateStatus } from 'src/app/GlobalVariables';
import { GetDictionaryList, PaginatedDTO } from 'src/app/Common/common.interface';
import { resolveTenantUrl, tenantOverrideOptions } from 'src/app/Common/ApiConfigurationService/resolve-tenant-url.util';

@Injectable({
  providedIn: 'root'
})
export class UserMasterService {

  http = inject(HttpClient)

  constructor() { }

  UserMaster_create(data: UserCreateRequestDTO): Observable<UserDTO> {
    return this.http.post<UserDTO>(UserMaster_create, data)
  }

  UserMaster_update(data: UserUpdateRequestDTO): Observable<UserDTO> {
    return this.http.post<UserDTO>(UserMaster_update, data)
  }

  UserMaster_updateStatus(data: UserUpdateStatusRequestDTO) : Observable<UserDTO> {
    return this.http.post<UserDTO>(UserMaster_updateStatus, data)
  }

  // baseUrlOverride (optional): the viewed tenant's own AM gateway origin,
  // e.g. CompanyDetailComponent.apiConfigOverride.AM (company-users tab).
  // Omitted for every other caller - behaves exactly as before.
  UserMaster_readById(data: UserReadByUserIdRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<UserDTO> {
    return this.http.post<UserDTO>(resolveTenantUrl(UserMaster_readById, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0))
  }

  UserMaster_readAll():Observable<UserList> {
    return this.http.get<UserList>(UserMaster_readAll)
  }

  UserMaster_readAllPaginated(data: PaginatedDTO): Observable<UserList> {
    return this.http.post<UserList>(UserMaster_readAllPaginated, data)
  }

  UserMaster_delete(data: UserDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(UserMaster_delete, data)
  }

  UserMaster_SearchByName(companyId:number, branchId:number, searchText:string) : Observable<UserList>{
    return this.http.get<UserList>(UserMaster_SearchByName + `?CompanyId=${companyId}&BranchId=${branchId}&SearchText=${searchText}`)
  }

  UserMaster_GetDictionary(data: UserMasterGetDictionaryRequestDTO): Observable<GetDictionaryList> {
    return this.http.post<GetDictionaryList>(UserMaster_GetDictionary, data);
  }

}
